module.exports = __webpack_public_path__ + "media/images/icon/send-a1b46391b550b5becaaac26e35aaf98a.svg";